import React, { useState, useCallback, useEffect } from 'react';
import axios from 'axios';
import './search-result.css';
import busLogo from '../images/bus_logo_white.png'

export default function SearchResults({results, loading, clickedAddNewBusOrTrain}) {
  const [loadingOrNoResults, setLoadingOrNoResults] = useState('loading')

  useEffect(() => {
    if(loading){
      setLoadingOrNoResults('Loading')
    }
    else{
      setLoadingOrNoResults('No results')
    }
  }, [loading])

  function clickedRoute(stop){
    clickedAddNewBusOrTrain(stop)
  }

  return (
    <ul className='search-results-unordered-list'>
        {results.length > 0 || (document.getElementById('search-bar-input') && document.getElementById('search-bar-input').value == '') ? (
        results.map((stop) => (
          <li className='search-results-list-item-container' key={stop.route} onClick={() => clickedAddNewBusOrTrain(stop.busNumber)}>
            <div className='search-result-item-container'>
              <img src={busLogo} className='search-results-image'/>
              <div className='search-results-item-halves-container'>
                <div className='search-results-item-half'>
                  {stop.busNumber}
                </div>
                <div className='search-results-item-half'>
                  {stop.route}
                </div>
              </div>
            </div>
            <div className='search-result-line-divider-container'>
              <div className='search-result-line-divider'></div>
            </div>
          </li>

        ))
        ) : (
          <li className='search-results-loading-list-item'>{loadingOrNoResults}</li>
        )}
    </ul>
  )
};
